import { Config } from 'config/envConfig';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { getUrl } from '../components/pdfDisplay/utils';

export const usePlanData = (email = null) => {
    const [plans, setPlans] = useState([]);
    const [currencyInfo, setCurrencyInfo] = useState({ currency_code: 'USD', local_price: 20, usd_price: 20, rate: 1 });
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchAllPlanDetails = async () => {
            try {
                const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
                const params = { tz };
                if (email) params.email = email;
                const response = await axios.get(
                    getUrl(
                        `http://${Config.FAST_API_HOST}:${Config.FAST_API_PORT}/subscription_routes/subscription-plans`
                    ),
                    { params }
                );
                setPlans(response.data.plans);
                if (response.data.currency) setCurrencyInfo(response.data.currency);
                setError(null);
            } catch (error) {
                console.error('Error fetching plan details:', error);
                setError(
                    'Failed to load subscription plans. Please try again later.'
                );
            }
        };

        fetchAllPlanDetails();
    }, [email]);

    return { plans, currencyInfo, error };
};
